import { getEntitlement } from '@/features/subscription/api';
import { useAsync, type AsyncState } from '@/lib/useAsync';
import type { SubscriptionEntitlement } from '@/features/subscription/api';

/**
 * The caller's current Mollie entitlement (`GET /subscriptions/entitlement`).
 * Reused wherever the account menu or a page needs a fast read of
 * active/tier without re-fetching.
 */
export function useSubscriptionStatus(): AsyncState<SubscriptionEntitlement> {
  return useAsync(() => getEntitlement(), []);
}
